<template>
  <v-navigation-drawer
    style="z-index: 8"
    color="bg_Greeny_Gray"
    v-model="drawer"
    dark
    :mini-variant.sync="mini"
    :permanent="!$vuetify.breakpoint.mobile"
    app
    class="elevation-0"
    width="300"
    :temporary="$vuetify.breakpoint.mobile">
    <div class="navToggler">
      <v-img class="upper" v-if="$vuetify.theme.dark" src="@public/img/Up_Dark.svg"></v-img>
      <v-img class="upper" v-else src="@public/img/Up.svg"></v-img>
      <v-img class="lower" v-if="$vuetify.theme.dark" src="@public/img/Down_Dark.svg"></v-img>
      <v-img class="lower" v-else src="@public/img/Down.svg"></v-img>
      <v-btn class="miniToggle" dark icon depressed :ripple="false" @click.stop="mini = !mini">
        <v-icon color="grey" v-if="!mini">mdi-chevron-left</v-icon>
        <v-icon color="grey" v-else>mdi-chevron-right</v-icon>
      </v-btn>
    </div>
    <!-- Logo removed - AVA logo is now in the top navigation bar -->
    <v-list-item class="d-flex justify-center" :class="{ 'px-1': mini }" v-if="!mini">
      <v-tooltip right>
        <template v-slot:activator="{ on, attrs }">
          <h3
            v-bind="attrs"
            v-on="on"
            class="mx-3"
            style="
              overflow-x: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              color: var(--v-grey-base);
            ">
            {{ facilityName }}
          </h3>
          <v-btn icon>
            <v-badge v-if="hasNewNotifications" color="pink" dot offset-y="12" offset-x="10">
              <v-icon color="primary" @click="showNotifications = true"> mdi-bell-outline </v-icon>
            </v-badge>
            <v-icon v-else color="primary" @click="showNotifications = true">
              mdi-bell-outline
            </v-icon>
          </v-btn>
        </template>
        <span>{{ facilityName }}</span>
      </v-tooltip>
    </v-list-item>

    <v-list-item class="px-2" v-if="showNotifications" style="height: 77vh">
      <system-notifications
        :isMenuClosed="menuClosed"
        :insideNav="true"
        @showNotifications="handleShowNotifications($event)"></system-notifications>
    </v-list-item>
    <!-- <v-list-item class="d-flex justify-center">
        <v-btn class="ml-2" v-if="mini" icon @click.stop="mini = !mini">
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </v-list-item> -->

    <v-list v-else class="main-nav-list overflow-x-hidden" v-model="selectedRoute">
      <template v-for="(item, k) in menu">
        <v-list-group v-if="item.items" :key="item.title" v-model="openList[k]">
          <template v-slot:activator>
            <v-list-item-icon class="mr-2 justify-center my-2 align-self-center">
              <v-img
                small
                v-if="item.img"
                :src="item.img"
                width="16px"
                :style="{
                  'opacity-54': !$route.path.startsWith(item.path),
                }"></v-img>
              <v-icon
                small
                color="grey"
                v-else
                :style="{
                  'opacity-54': !$route.path.startsWith(item.path),
                }"
                >{{ item.icon }}</v-icon
              >
            </v-list-item-icon>
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-list-item-content class="py-1" v-bind="attrs" v-on="on">
                  <v-list-item-title class="custom-list-item-title" color="grey">
                    {{ item.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>
              <span>{{ item.title }}</span>
            </v-tooltip>
          </template>
          <template v-if="!mini">
            <div  v-for="child in item.items" :key="child.title">
              <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                    <span  v-bind="attrs"
                    v-on="on">
                    <v-list-item
              class="pl-10"
              :key="child.title"
              :disabled="!$has(child.roles)"
              :class="{ 'v-list-item--active': $route.path.startsWith(child.path) }"
              @click="handleClick(child)">
              <v-list-item-icon class="mr-2 justify-center my-2 align-self-center">
                <v-img
                  small
                  v-if="child.img"
                  :src="child.img"
                  width="16px"
                  :style="{
                    'opacity-54': !$route.path.startsWith(child.path),
                  }"></v-img>
                <v-icon
                  small
                  color="grey"
                  v-else
                  :style="{
                    'opacity-54': !$route.path.startsWith(child.path),
                  }"
                  >{{ child.icon }}</v-icon
                >
              </v-list-item-icon>
              <v-list-item-content class="py-1">
                <v-list-item-title :class="['custom-list-item-title']"><span :class="{'text--disabled':!$has(child.roles)}">   {{
                  child.title
                }} </span></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
                    </span>
                  </template>
                  <span>  {{ $has(child.roles)? child.title:'Permission Required' }} </span>
                </v-tooltip>
            
          </div>
          </template>
        </v-list-group>

        <template v-else>
          <v-tooltip   right :key="item.title">
                  <template v-slot:activator="{ on, attrs }">
                    <span  v-bind="attrs"
                    v-on="on">
                    <v-list-item
                     
            v-if="item.isAdmin ? isAdmin : true"
            
            :disabled="!$has(item.roles)"
            :class="{ 'v-list-item--active primary--text': $route.path.startsWith(item.path) }"
            :key="k"
            :ripple="false"
            @click="handleClick(item)"
            :target="item.target">
            <v-list-item-icon class="mr-2 justify-center my-2 align-self-center">
              <v-img
                small
                v-if="item.img"
                :src="item.img"
                width="16px"
                :style="{
                  'opacity-54': !$route.path.startsWith(item.path),
                }"></v-img>
              <v-icon
                small
                color="grey"
                v-else
                :style="{
                  'opacity-54': !$route.path.startsWith(item.path),
                }"
                >{{ item.icon }}</v-icon
              >
            </v-list-item-icon>
            <v-list-item-content class="py-1">
              <v-list-item-title class="custom-list-item-title">
                <span :class="{'text--disabled':!$has(item.roles)}">   {{
                  item.title
                }} </span>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </span>
                  </template>
                  <span>  {{ $has(item.roles)? item.title:'Permission Required' }} </span>
                </v-tooltip>

      
        </template>
      </template>
    </v-list>
    <template v-slot:append>
      <div v-if="!mini" class="d-flex align-center justify-center pa-2 pb-4">
        <v-btn class="elevation-0" color="grey" block @click="handleHomeClicked">
          <span style="color: var(--v-white-base)"> Home</span></v-btn
        >
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
  import { $has } from '@/utils';
import permissions from '../config/permissions';
  import SystemNotifications from '@Share/components/SystemNotifications.vue';
  import { isAnyViewerOpen } from '@/scripts/js/forgeviewer';

  export default {
    data() {
      return {
        selectedRoute: null,
        mini: false,
        permissions,
        openList: { reality: true },
        drawer: true,
        showNotifications: false,
      };
    },
    components: {
      SystemNotifications,
    },
    computed: {
      isAdmin() {
        return this.$store.getters['ACCOUNT/IS_ADMIN'];
      },
      selectedProject() {
        return this.$store.getters['FACILITY/GET_FACILITY'];
      },
      menu() {
        return {
          reality: {
            title: 'A V A Admin',
            icon: 'mdi-cube-outline',
            opened: false,
            roles: ['All'],
            items: [
              {
                title: 'Models',
                path: `/${this.$route.params.id}/admin/models`,
                icon: 'mdi-cube-outline',
                opened: false,
                roles: [permissions.Admin3DModels.View],
              },
              {
                title: 'Tag Harvester',
                path: `/${this.$route.params.id}/admin/tagHarvesters`,
                icon: 'mdi-tag-outline',
                opened: false,
                roles: [permissions.TagHarvester.View],
              },
              {
                title: 'Levels & Plans',
                path: `/${this.$route.params.id}/admin/LevelAndArea`,
                icon: 'mdi-filter-variant',
                opened: false,
                roles: [permissions.AdminFacilityLevels.View],
              },
              {
                title: 'Area',
                path: `/${this.$route.params.id}/admin/areas`,
                icon: 'mdi-map-marker-radius',
                opened: false,
                roles: [permissions.Areas.View],
              },
              {
                title: 'Point Clouds',
                path: `/${this.$route.params.id}/admin/pointCloud`,
                icon: 'mdi-cloud',
                opened: false,
                roles: [permissions.AdminPointClouds.Upload],
              },
              {
                title: `360's`,
                path: `/${this.$route.params.id}/admin/projects`,
                icon: 'mdi-folder-multiple-outline',
                opened: false,
                 roles: [permissions.Admin360Images.View],
              },
              {
                title: 'GPS Settings',
                path: `/${this.$route.params.id}/admin/GPSSettings`,
                icon: 'mdi-map-outline',
                opened: false,
                roles: [permissions.GPSSettings.Access],
              },
              {
                title: 'Categories',
                path: `/${this.$route.params.id}/admin/Categories`,
                icon: 'mdi-shape-plus',
                opened: false,
                roles: [permissions.Categories.View],
              },
              {
                title: 'Mark-up Stamps',
                path: `/${this.$route.params.id}/admin/markupsStamps`,
                icon: 'mdi-brush-variant',
                opened: false,
                roles: [permissions.AdminMarkupsStamps.View],
              },
              {
                title: 'Symbols',
                path: `/${this.$route.params.id}/admin/symbols`,
                icon: 'mdi-symbol',
                opened: false,
                roles: [permissions.AdminMarkupSymbols.View],
              },
              {
                title: 'Inspect',
                path: `/${this.$route.params.id}/admin/Inspections`,
                icon: 'mdi-file-find-outline',
                opened: false,
                roles: [permissions.InspectionTags.View],
              },
              {
                title: 'Bulk Import',
                path: `/${this.$route.params.id}/admin/bulkImport`,
                icon: 'mdi-table-arrow-right',
                opened: false,
                roles: [permissions.Tags.Masters.Update],
              },
              {
                title: 'General Settings',
                path: `/${this.$route.params.id}/admin/setting`,
                icon: 'mdi-cog-outline',
                opened: false,
                roles: [permissions.GeneralSettings.View],
              },
            ],
          },

          contracts: {
            title: 'Contracts',
            path: `/${this.$route.params.id}/admin/contracts`,
            icon: 'mdi-folder-multiple-outline',
            opened: false,
            roles: [permissions.Contracts.View],
          },
          taskManager: {
            title: 'Task Board Manager',
            path: `/${this.$route.params.id}/admin/task-manager`,
            icon: 'mdi-file-tree',
            opened: false,
            roles: [permissions.AdminTaskManager.View],
          },

      
        };
      },
      facility: {
        get() {
          return this.$store.getters['FACILITY/GET_FACILITY'];
        },
      },
      facilityName() {
        return this.facility?.name || '';
      },
      hasNewNotifications: {
        get() {
          return this.$store.getters['NOTIFICATIONS/GET_HAS_NEW_NOTIFICATION'];
        },
      },
    },
    methods: {
      $has,
      handleClick(item) {
        if (item.path) {
          this.$router.push(item.path);
        }
      },
      handleShowNotifications(event) {
        this.showNotifications = event;
      },
      handleLogoClicked() {
        this.navigateWithViewerWarning('/');
      },
      handleHomeClicked() {
        this.navigateWithViewerWarning(`/${this.$route.params.id}`);
      },
      navigateWithViewerWarning(path) {
        if (isAnyViewerOpen()) {
          this.$dialog.warning({
            text: 'You have a viewer open. Navigating away will close it. Are you sure you want to continue?',
            title: 'Close Viewer',
            actions: {
              false: 'Cancel',
              true: {
                text: 'Continue',
                color: 'primary',
                handle: () => {
                  this.$router.replace(path);
                },
              },
            },
          });
        } else {
          this.$router.replace(path);
        }
      },
    },
  };
</script>

<style lang="scss">
  .v-navigation-drawer {
    border-top-right-radius: 15px;
    .navToggler {
      position: absolute;
      right: -34px;
      top: 50%;
      width: 39px;
      height: 114px;
      background-color: var(--v-bg_Greeny_Gray-base);
      display: flex;
      align-items: center;
      .upper {
        position: absolute;
        top: -27px;
        width: 40px;
      }
      .lower {
        position: absolute;
        bottom: -27px;
        width: 40px;
      }
    }
    .v-navigation-drawer__border {
      display: none;
    }
    .v-list::-webkit-scrollbar-thumb {
      background-color: #9e9e9e;
    }
    .v-icon {
      color: var(--v-grey-base);
    }
  }
  .v-navigation-drawer__content::-webkit-scrollbar-thumb {
    background-color: #9e9e9e;
  }
  .v-navigation-drawer__content::-webkit-scrollbar-thumb:hover {
    background-color: #7f7f7f;
  }
  .logoContainer {
    position: relative;
  }
  .logoContainer .miniToggle {
    position: absolute;
    right: 0px;
  }
  .main-nav-list {
    max-height: 82%;
    overflow: auto;
    overflow-x: hidden;
  }
</style>
